import angular, { ITimeoutService } from 'angular';
import { SharedAngular } from '../../@types/sharedAngular';
import { IFieldOptionQuery } from '@Shared.Angular/@types/fieldOptions';
import FieldDataSource from '@Shared.Angular/@types/fieldDataSource';
import { FormFieldType } from '@Shared.Angular/@types/formFieldType';

angular
  .module('fg')
  .directive('fgFieldSelectList', [
    'fgFieldSelectListLinkFn',
    function (fgFieldSelectListLinkFn) {
      return {
        replace: true,
        templateUrl:
          'angular-form-gen/field-templates/default/selectlist.ng.html',
        scope: true,
        link: fgFieldSelectListLinkFn,
        require: ['^?fgForm']
      };
    }
  ])
  .factory('fgFieldSelectListLinkFn', [
    '$timeout',
    'flowinglyConstants',
    'fieldService',
    'APP_CONFIG',
    'currencyService',
    function (
      $timeout: ITimeoutService,
      flowinglyConstants: SharedAngular.FlowinglyConstants,
      fieldService: SharedAngular.FieldService,
      APP_CONFIG: SharedAngular.APP_CONFIG,
      currencyService: SharedAngular.CurrencyService
    ) {
      return function ($scope, $element, $attrs, ctrls) {
        const fgForm = ctrls[0];
        $scope.formCtrl = fgForm;
        const currentStepFields = fgForm?.flowFields || [];
        // There are few flows models which has first option as Please Choose
        // which should be removed from field as below placeholder is being added for same purpose.
        if (
          $scope.field.schema.options &&
          $scope.field.schema.options.length > 0 &&
          $scope.field.schema.options[0].text === 'Please Choose' &&
          $scope.field.schema.options[0].value === ''
        ) {
          $scope.field.schema.options.splice(0, 1);
        }

        //this is placeholder text used in kendo control.
        $scope.options = {
          optionLabel: 'Please Choose...',
          dataBound: disableOuterScrolling,
          filter: $scope.field.schema.searchable === true ? 'contains' : 'none'
        };

        $scope.field.schema.filteredOptions = angular.copy(
          $scope.field.schema.options
        );

        if ($scope.field.schema.searchable === true) {
          $timeout(function () {
            if (
              $scope.field.schema.filteredOptions.length >
                APP_CONFIG.maxReturnRecords &&
              $scope.form.data[$scope.field.schema.name]
            ) {
              $scope.field.schema.filteredOptions =
                $scope.field.schema.filteredOptions.slice(
                  0,
                  APP_CONFIG.maxReturnRecords
                );
            }

            // If the selected value is not present in the initial dropdown list, appends the text and value from fields object.
            updateFilteredOptions();

            $scope.options.filtering = function (event) {
              const filter = event.filter;
              event.preventDefault();

              if ($scope.field.schema.dataSource === FieldDataSource.MANUALLY) {
                if (!filter.value || filter.value === '') {
                  $scope.field.schema.filteredOptions = angular.copy(
                    $scope.field.schema.options
                  );
                } else {
                  $scope.field.schema.filteredOptions =
                    $scope.field.schema.options.filter(function (val) {
                      return (
                        val.text
                          .toLowerCase()
                          .indexOf(filter.value.toLowerCase()) >= 0
                      );
                    });
                }

                $scope.field.schema.filteredOptions =
                  $scope.field.schema.filteredOptions.slice(
                    0,
                    APP_CONFIG.maxReturnRecords
                  );

                $timeout(function () {
                  this.setDataSource($scope.field.schema.filteredOptions);
                  this.refresh();
                });
              } else {
                const requestPayload: IFieldOptionQuery = {
                  fieldName: $scope.field.name,
                  dbDataSource: angular.copy($scope.field.schema.dbDataSource),
                  flowModelId: $scope.formCtrl.formModelId,
                  searchable: true,
                  searchablePageSize: APP_CONFIG.maxReturnRecords,
                  searchTerm: filter.value,
                  flowId: $scope.formCtrl.flowInstanceId
                };

                if ($scope.field.schema.dbDataSource?.filters?.length > 0) {
                  const filter = $scope.field.schema.dbDataSource.filters[0];
                  const filterFieldName = filter.value;

                  const filterField = $scope.form.schema.fields.find(
                    (x) => x.name === filterFieldName
                  );

                  const isExcludedField =
                    flowinglyConstants.excludedSpecialFields.includes(
                      filter.value
                    );

                  if (!isExcludedField) {
                    const rawValue = $scope.form.data[filterFieldName];
                    const isCurrency =
                      filterField?.type === FormFieldType.CURRENCY;
                    const parsed = isCurrency
                      ? currencyService.parseNumber(rawValue)
                      : rawValue;

                    requestPayload.dbDataSource.filters[0].value =
                      Number.isFinite(parsed) || !isCurrency
                        ? parsed
                        : rawValue;
                  }

                  const isManual =
                    filterField?.dataSource === FieldDataSource.MANUALLY;

                  // If manual dropdown, get the text value instead of the option value
                  if (isManual) {
                    const selectedOption = filterField?.options?.find(
                      (option) =>
                        option.value === $scope.form.data[filterFieldName]
                    );
                    requestPayload.dbDataSource.filters[0].value =
                      selectedOption?.text || '';
                  }
                }

                fieldService
                  .getFieldOptions($scope.formCtrl.isPublic, [requestPayload])
                  .then(function (results) {
                    if (results && results.length > 0) {
                      $scope.field.schema.options = results[0].options;
                      $scope.field.schema.filteredOptions = angular.copy(
                        $scope.field.schema.options
                      );
                    }
                  });
              }
            };
          });
        }

        function updateFilteredOptions() {
          const searchValue = $scope.form.data[$scope.field.schema.name];
          const schemaName = $scope.field.schema.name;

          const field = currentStepFields.find(
            (field) => field.Name === schemaName
          );

          const filteredOptionsList = $scope.field.schema.filteredOptions
            .filter(
              (option) =>
                option.value === searchValue ||
                (option.text && option.text.includes(searchValue))
            )
            .slice(0, APP_CONFIG.maxReturnRecords);

          if (searchValue && field && searchValue === field.Value) {
            if (filteredOptionsList.length === 0) {
              // Retain existing options and append the new option

              const dataSource = $scope.field.schema.dbDataSource;
              if (
                (dataSource?.dbName ===
                  flowinglyConstants.tableColumnsName.Users &&
                  dataSource?.displayValue ===
                    flowinglyConstants.tableColumnsName.Email) ||
                (dataSource?.dbName ===
                  flowinglyConstants.tableColumnsName.Teams &&
                  dataSource?.displayValue ===
                    flowinglyConstants.tableColumnsName.TeamName)
              ) {
                const requestPayload: IFieldOptionQuery = {
                  fieldName: $scope.field.name,
                  dbDataSource: angular.copy(dataSource),
                  flowModelId: $scope.formCtrl.formModelId,
                  searchable: true,
                  searchablePageSize: APP_CONFIG.maxReturnRecords,
                  searchTerm: ''
                };

                requestPayload.dbDataSource.filters = [
                  {
                    column: 'Id',
                    operation: '=',
                    value: field.Value
                  }
                ];

                fieldService
                  .getFieldOptions($scope.formCtrl.isPublic, [requestPayload])
                  .then(function (results) {
                    if (results && results.length > 0) {
                      $scope.field.schema.filteredOptions = [
                        ...$scope.field.schema.filteredOptions,
                        ...results[0].options
                      ];
                    }

                    $timeout(() => {
                      $scope.form.data[$scope.field.schema.name] = field.Value;
                    });
                  });
              } else {
                $scope.field.schema.filteredOptions = [
                  ...$scope.field.schema.filteredOptions,
                  { value: field.Value, text: field.Text }
                ];
              }
            }
          } else if (filteredOptionsList.length > 1) {
            $scope.field.schema.filteredOptions = filteredOptionsList;
          }
        }

        function disableOuterScrolling(e) {
          $('.k-list-scroller').on('mousewheel DOMMouseScroll', function (e) {
            if (e.currentTarget.scrollHeight === e.currentTarget.offsetHeight) {
              return;
            }

            let delta = 0;
            if (e.originalEvent.wheelDelta) {
              // will work in most cases
              delta = e.originalEvent.wheelDelta;
            } else if (e.originalEvent.detail) {
              // fallback for Firefox
              delta = -e.originalEvent.detail;
            }
            const scrollTop = $(e.currentTarget).scrollTop();
            if (
              (delta < 0 &&
                scrollTop ==
                  e.currentTarget.scrollHeight -
                    e.currentTarget.offsetHeight) ||
              (delta > 0 && scrollTop == 0)
            ) {
              e.preventDefault();
            }
          });
        }
      };
    }
  ]);
